/**
 * 插件加载器 fetch 方法（兜底，当用户没有传递 apiFetch 则使用该方法发起请求）
 * 用于获取插件详情，访问插件调度中心，保存插件数据等和业务操作无关的接口
 */
import qs from 'qs'
import axios from 'axios'
import { getGlobalData } from './common'
// import { getStoreData } from 'cseed-frame/store/_index'

const instance = axios.create({
  timeout: 50000
})

export default function createFetch ({ urlPrefix, axiosOptions }) {
  return function ({
    method = 'get',
    url,
    data,
    params,
    options = {},
    headers = {},
    isJSON = true,
    emptyToken = false, // 是否需要token
    isFile = false,
    successCodes = []
  }) {
    console.log(`[@ccprivate/plugin-engine-saas] createFetch: ${method} ${url}`)
    let pushData = null
    if (isJSON || data instanceof FormData) {
      pushData = data
    } else {
      if (typeof data === 'string') {
        pushData = data
      } else {
        pushData = qs.stringify(data)
      }
    }

    const option = {
      method,
      url: `${urlPrefix}${url}`,
      data: pushData,
      params,
      ...axiosOptions,
      ...options
    }
    let token = ''
    if (emptyToken) {
      token = ''
    } else {
      // 暂时写死从cookie中获取，需要修改
      token = getGlobalData('token') // 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mbyI6InNlY3VyaXR5OmF5RGRlTVR1UitPOGM2SWxiZ2REaDZvWVBDV2xsTUpRUElrd21zZE15N1RhRlJ6blp2ZEZEdDlhSXVDeVpvNEg4bWVZSWlMTXVZbE5Wb0pNbURTQ292UFJMdDExNmRjcEhwd1VJWW04VDM0UHdIaTVLSjA3OFFBZkFlWUo5eC96N2J3V0Yxd1lkamFwNmRuRnJMOS9WaENObCsvQmtGVzZWemhCSnN3OGFHTlhpWE16LzB0ZjBlUVNBNFFjSEg5Y1ZEV3dobStBKzd3VkhCWHcvR0dUOTZ3T3craTMxOHdhczVoSWYySUVLNmM5NlFpM1NDWWJQOU1ibXhGVU1QcUtIektJcW95U01TcWdQQjdBTC9zTUt3SWpuL3dCNFhpMVE5Z2s5eHJsL2xRSHVhajdUcEdiQitEQW1zL0djR3NFcFByWXBUNDJMT2xXMTh2bVRyRUkyWEc3RGF6aXlXK2JZVzhpdVJKbGpPOD0iLCJ1c2VyUGVybUtleSI6ImxpZGlhbmJpbkBjb29jYWEuY29tX3Blcm1fa2V5IiwiZGVwTmFtZSI6Iui9r-S7ti3liY3nq6_mioDmnK_nu4QiLCJjbGllbnRfaWQiOiI5SDExYTYxMnJRbFVrY2Q4Iiwicm9sZUlkcyI6bnVsbCwicGluIjozLCJkZXBVbmlxdWVJZCI6IjE2ODk3MTM3MjUwMjU1NTAzMzYiLCJzY29wZSI6WyJhcHAiXSwibmlja25hbWUiOiLmnY7lhbjmlowiLCJ0ZW5hbnRJZCI6IjYzNGQxYzg5ZDU2ZDQ3ZWRhNTY4NDQ4MGVjODg4ZTIzIiwiaWQiOjU1LCJleHAiOjE2OTcyMzUxNjQsInJvbGVOYW1lcyI6bnVsbCwidW5pcXVlSWQiOiIxNTIyMTE2MzE4ODYwNDEwODgwIiwianRpIjoiNTA2NmUxOGUtOWVmZC00YzgwLTgwYzUtYjNjNjYzMTdkODAwIiwidXNlcm5hbWUiOiJsaWRpYW5iaW5AY29vY2FhLmNvbSJ9.sgghs1HnjLg8ck7zAVXE8xYRzd1UrS8RwAcY_YQukvaoB20DJX4ZjnidJzCIISezUs8bn8BRo3HeTchJBuvQT1oyfsORyqZD_5ZTMykIBB7H9sFU-Sk2f1vz-088pFGB9jJcTRJDLEhcWis5DYMcGmfDk7RePKwfz5WXEqYIWuqPsemWAt1dp8qyqyRoBagB9qXwEUIp7tJar0nBnwJA7yrFZpGQ3clXyeJOrN6FCdJBGBAlz42G-8VTGSeJe-F8FOnB_vWfZ5vkgdaUrkkOcALgxrsGi84ugTGorUNJe-n7-bo7Yit7oXq498rA_CfXaZTURqU6d0AbnFh2BpSt1g'
      console.log('----> token', getGlobalData('token'))
      // token = getStoreData('token')
    }

    // const app = this.app
    option.headers = {
      // ...(getStoreData('httpHeaders') || {}),
      AccessToken: token || '',
      ...headers
    }
    return instance(option)
      .then(function (res) {
        if (isFile) {
          return res
        }
        const { data } = res
        const isSuccess = [1000, 200].concat(successCodes).findIndex(code => String(code) === String(data.code)) > -1
        if (data.success || isSuccess) {
          // return data.data || data
          return data
        } else {
          // eslint-disable-next-line no-throw-literal
          throw {
            code: data.code,
            message: data.msg || data.message
          }
        }
      })
      .catch(e => {
        if (e.response) {
          const { data, status, statusText } = e.response
          e = {
            code: String(data.code || status),
            message: data.message || data.msg || statusText || '请求错误'
          }
        } else if (e instanceof Error) {
          e = {
            code: e.name,
            message: e
          }
        }

        throw e
      })
      // .finally(() => {
      // })
  }
}
